import { render, staticRenderFns } from "./ActorList.vue?vue&type=template&id=2b58306b&scoped=true"
import script from "./ActorList.vue?vue&type=script&lang=js"
export * from "./ActorList.vue?vue&type=script&lang=js"
import style0 from "./ActorList.vue?vue&type=style&index=0&id=2b58306b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b58306b",
  null
  
)

export default component.exports